<template>
  <div class="container_welcome">
    <div class="welcome_content">
      <h1>Hello, I'm Ronnel Sanchez.</h1>
      <h2>UI/UX Designer and Front-End Developer.</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome'
}
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue